import React from 'react'

export const Spinner = () => {
  return (
    <div className="loadingSpinerContainer">
        <div className="loadingSpinner"></div>
    </div>
  )
}
